var map = {
	"./Archiver.PNG": 53268,
	"./AshOni.PNG": 71032,
	"./BlackBride.PNG": 87155,
	"./BloodyCryptZombie.PNG": 26795,
	"./BurntCryptZombie.PNG": 75277,
	"./Centipede.PNG": 90553,
	"./Clarice.PNG": 79999,
	"./Clown.PNG": 96213,
	"./Clubfoot.PNG": 94960,
	"./Creep.PNG": 79453,
	"./CrimsonLady.PNG": 40409,
	"./Crocodile.PNG": 81938,
	"./CryptStalkerWhite.PNG": 51697,
	"./CryptZombie.PNG": 58396,
	"./Feeler.PNG": 82593,
	"./FrostFoot.PNG": 98432,
	"./HunterPigman.PNG": 54014,
	"./JokerSmiley.PNG": 91010,
	"./Leech.PNG": 40865,
	"./MamaSwampDog.PNG": 48338,
	"./Marionette.PNG": 56408,
	"./Miner.PNG": 13887,
	"./Mosquito.PNG": 52325,
	"./Nameless.PNG": 95086,
	"./PartyGoer.PNG": 62273,
	"./PartyGoerCyan.PNG": 71244,
	"./PartyGoerGreen.PNG": 41960,
	"./PartyGoerPink.PNG": 75829,
	"./PartyGoerYellow.PNG": 22801,
	"./Pigman.PNG": 47192,
	"./PigmanV2.PNG": 5140,
	"./Rat.PNG": 48875,
	"./RedOni.PNG": 34951,
	"./ScareCrow.PNG": 96191,
	"./ScareCrowV2.PNG": 11119,
	"./SmileyV2.PNG": 45157,
	"./SmolderWickerman.PNG": 96811,
	"./SwampDog.PNG": 78758,
	"./TrenchStalker.PNG": 23076,
	"./Vampire.PNG": 93372,
	"./Wickerman.PNG": 84303,
	"./WickermanV2.PNG": 28031,
	"./WinterWitch.PNG": 29926,
	"./Witch.PNG": 23803,
	"./smiley.PNG": 42917
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 36923;